import { useMemo } from "react";
import { useLocation } from "react-router-dom";
import { INSURANCE_PLAN_RISKS } from "utils/constants";
import CreateHealth from "./Health";
import EditService from "./Service";
import CreateTerminal from "./Terminal";

const VIEW_BY_RISK = {
  [INSURANCE_PLAN_RISKS.HEALTH]: () => <CreateHealth />,
  [INSURANCE_PLAN_RISKS.TERMINAL]: () => <CreateTerminal />,
  [INSURANCE_PLAN_RISKS.PROVIDENT]: () => (
    <CreateHealth risk={INSURANCE_PLAN_RISKS.PROVIDENT} />
  ),
  [INSURANCE_PLAN_RISKS.SERVICE]: () => <EditService />,
  // Temporary: reuse the health edit screen for sports & leisure plans.
  [INSURANCE_PLAN_RISKS.SPORTS_LEISURE]: () => (
    <CreateHealth risk={INSURANCE_PLAN_RISKS.SPORTS_LEISURE} />
  ),
  [INSURANCE_PLAN_RISKS.PRO]: () => (
    <CreateHealth risk={INSURANCE_PLAN_RISKS.PRO} />
  ),
};

const Edit = (props) => {
  const { state } = useLocation();
  const View = useMemo(
    () =>
      VIEW_BY_RISK[state?.risk] || VIEW_BY_RISK[INSURANCE_PLAN_RISKS.HEALTH],
    [state?.risk],
  );

  return View(props);
};

export default Edit;
